<script>
import {
	buildUpdatePolicy,
	buildUpdatePolicyFact,
	buildAddPolicyFact,
	buildRemovePolicyFact
} from "./SectionPolicy/queries.js"
import {
	buildUpdateContractHolderAddress,
	buildUpdateContractHolderContact,
	buildUpdateContractHolderFact,
	buildUpdateContractHolderIdentity,
	buildAddContractHolderContact,
	buildAddContractHolderAddress,
	buildAddContractHolderIdentity,
	buildAddContractHolderFact,
	buildRemoveContractHolderAddress,
	buildRemoveContractHolderContact,
	buildRemoveContractHolderFact,
	buildRemoveContractHolderIdentity
} from "./SectionHolder/queries.js"
import { buildAddAddClauseToEndorsement } from "./SectionClauses/queries.js"
import {
	buildUpdateOtherContractHolderAddress,
	buildUpdateOtherContractHolderCompany,
	buildUpdateOtherContractHolderContact,
	buildUpdateOtherContractHolderFact,
	buildUpdateOtherContractHolderIdentity,
	buildUpdateOtherContractHolderIndividual,
	buildAddOtherContractHolderContact,
	buildAddOtherContractHolderAddress,
	buildAddOtherContractHolderIdentity,
	buildAddOtherContractHolderFact,
	buildRemoveOtherContractHolderAddress,
	buildRemoveOtherContractHolderContact,
	buildRemoveOtherContractHolderFact,
	buildRemoveOtherContractHolderIdentity,
	buildRemoveOtherContractHolder
} from "./SectionOtherHolders/queries.js"
import {
	buildUpdateContractInsuredAddress,
	buildUpdateContractInsuredCompany,
	buildUpdateContractInsuredContact,
	buildUpdateContractInsuredFact,
	buildUpdateContractInsuredIdentity,
	buildUpdateContractInsuredIndividual,
	buildUpdateContractInsuredObject,
	buildAddContractInsuredContact,
	buildAddContractInsuredAddress,
	buildAddContractInsuredIdentity,
	buildAddContractInsuredFact,
	buildRemoveContractInsuredContact,
	buildRemoveContractInsuredFact,
	buildRemoveContractInsuredIdentity,
	buildRemoveContractInsuredAddress,
	buildRemoveContractInsured
} from "./SectionInsured/queries.js"
import {
	buildRemoveDiscount,
	buildAddDiscount,
	buildAddLoading,
	buildRemoveLoading
} from "./SectionPremium/queries.js"
import {
	buildAddAssociatedContractToPolicy,
	buildRemoveAssociatedContractFromPolicy
} from "./SectionBinders/queries.js"
import {
	buildUpsertBenefitOptionOfPolicy,
	buildRemoveBenefitOptionFromPolicy
} from "./SectionBenefitOptions/queries.js"
import dayjs from "dayjs"

/*
 * @param {errors} : res.errors in the graphQL response
 * @param {data} : res.data.<apiCall> in the graphQL response
 * @param: {store}: store, needed to create the error message
 */
const eHandler = function(errors, data, store) {
	if (data?.status !== "success") {
		store.dispatch("addMessage", {
			message: {
				type: "error",
				text: errors
					? errors
					: data?.errors
					? data?.errors
					: data?.errors_2?.message
					? data?.errors_2?.message
					: "Oops ! An error occured."
			}
		})
	}
}

// ********************* Build API functions ********************************
// Policy
const updatePolicy = buildUpdatePolicy(eHandler)
const updatePolicyFact = buildUpdatePolicyFact(eHandler)
const addPolicyFact = buildAddPolicyFact(eHandler)
const removePolicyFact = buildRemovePolicyFact(eHandler)
// Premium
const removeDiscount = buildRemoveDiscount(eHandler)
const addDiscount = buildAddDiscount(eHandler)
const removeLoading = buildRemoveLoading(eHandler)
const addLoading = buildAddLoading(eHandler)
// Clauses
const addAddClauseToEndorsement = buildAddAddClauseToEndorsement(eHandler)
// Holder
const updateContractHolderAddress = buildUpdateContractHolderAddress(eHandler)
const updateContractHolderContact = buildUpdateContractHolderContact(eHandler)
const updateContractHolderFact = buildUpdateContractHolderFact(eHandler)
const updateContractHolderIdentity = buildUpdateContractHolderIdentity(eHandler)

const removeContractHolderAddress = buildRemoveContractHolderAddress(eHandler)
const removeContractHolderContact = buildRemoveContractHolderContact(eHandler)
const removeContractHolderFact = buildRemoveContractHolderFact(eHandler)
const removeContractHolderIdentity = buildRemoveContractHolderIdentity(eHandler)
const addContractHolderContact = buildAddContractHolderContact(eHandler)
const addContractHolderAddress = buildAddContractHolderAddress(eHandler)
const addContractHolderIdentity = buildAddContractHolderIdentity(eHandler)
const addContractHolderFact = buildAddContractHolderFact(eHandler)
// Other holder
const updateOtherContractHolderAddress = buildUpdateOtherContractHolderAddress(
	eHandler
)
const updateOtherContractHolderCompany = buildUpdateOtherContractHolderCompany(
	eHandler
)
const updateOtherContractHolderContact = buildUpdateOtherContractHolderContact(
	eHandler
)
const updateOtherContractHolderFact = buildUpdateOtherContractHolderFact(
	eHandler
)
const updateOtherContractHolderIdentity = buildUpdateOtherContractHolderIdentity(
	eHandler
)
const updateOtherContractHolderIndividual = buildUpdateOtherContractHolderIndividual(
	eHandler
)
const removeOtherContractHolderAddress = buildRemoveOtherContractHolderAddress(
	eHandler
)
const removeOtherContractHolderContact = buildRemoveOtherContractHolderContact(
	eHandler
)
const removeOtherContractHolderFact = buildRemoveOtherContractHolderFact(
	eHandler
)
const removeOtherContractHolderIdentity = buildRemoveOtherContractHolderIdentity(
	eHandler
)
const addOtherContractHolderContact = buildAddOtherContractHolderContact(
	eHandler
)
const addOtherContractHolderAddress = buildAddOtherContractHolderAddress(
	eHandler
)
const addOtherContractHolderIdentity = buildAddOtherContractHolderIdentity(
	eHandler
)
const addOtherContractHolderFact = buildAddOtherContractHolderFact(eHandler)
const removeOtherContractHolder = buildRemoveOtherContractHolder(eHandler)
// Insured
const updateContractInsuredAddress = buildUpdateContractInsuredAddress(eHandler)
const updateContractInsuredCompany = buildUpdateContractInsuredCompany(eHandler)
const updateContractInsuredContact = buildUpdateContractInsuredContact(eHandler)
const updateContractInsuredFact = buildUpdateContractInsuredFact(eHandler)
const updateContractInsuredIdentity = buildUpdateContractInsuredIdentity(
	eHandler
)
const updateContractInsuredIndividual = buildUpdateContractInsuredIndividual(
	eHandler
)
const updateContractInsuredObject = buildUpdateContractInsuredObject(eHandler)
const addContractInsuredContact = buildAddContractInsuredContact(eHandler)
const addContractInsuredAddress = buildAddContractInsuredAddress(eHandler)
const addContractInsuredIdentity = buildAddContractInsuredIdentity(eHandler)
const addContractInsuredFact = buildAddContractInsuredFact(eHandler)
const removeContractInsuredAddress = buildRemoveContractInsuredAddress(eHandler)
const removeContractInsuredContact = buildRemoveContractInsuredContact(eHandler)
const removeContractInsuredFact = buildRemoveContractInsuredFact(eHandler)
const removeContractInsuredIdentity = buildRemoveContractInsuredIdentity(
	eHandler
)
const removeContractInsured = buildRemoveContractInsured(eHandler)
// Binders
const addAssociatedContractToPolicy = buildAddAssociatedContractToPolicy(
	eHandler
)
const removeAssociatedContractFromPolicy = buildRemoveAssociatedContractFromPolicy(
	eHandler
)
// Benefit Options
const upsertBenefitOptionOfPolicy = buildUpsertBenefitOptionOfPolicy(eHandler)
const removeBenefitOptionFromPolicy = buildRemoveBenefitOptionFromPolicy(
	eHandler
)

// ********************** helpers ***********************
// Returns a clone of an object
function deepClone(obj) {
	if (typeof obj !== "object") return obj
	if (obj === null) return null
	let clone = Object.assign({}, obj)
	Object.keys(clone).forEach(
		key =>
			(clone[key] =
				typeof obj[key] === "object" ? deepClone(obj[key]) : obj[key])
	)
	return Array.isArray(obj) && obj.length
		? (clone.length = obj.length) && Array.from(clone)
		: Array.isArray(obj)
		? Array.from(obj)
		: clone
}
// filter referenceId facts. Returns true if stringToTest is not a guid
function filterGuidAndObjectId(stringToTest) {
	if (!stringToTest) return true
	if (typeof stringToTest !== "string") return true
	var regexObjectId = /^[0-9a-f]{24}$/
	var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi
	return !(regexGuid.test(stringToTest) || regexObjectId.test(stringToTest))
}
// Return non-null value
const parseScalarValue = function(val) {
	if (!val) return null
	if (val.numberValue !== undefined && val.numberValue !== null)
		return val.numberValue
	if (val.stringValue !== undefined && val.stringValue !== null)
		return val.stringValue
	if (val.dateValue !== undefined && val.dateValue !== null)
		return val.dateValue
	if (val.booleanValue !== undefined && val.booleanValue !== null)
		return val.booleanValue
	if (val.arrayValue !== undefined && val.arrayValue !== null)
		return val.arrayValue
	if (val.objectValue !== undefined && val.objectValue !== null)
		return val.objectValue
	return null
}
// Return non-null value
const getDataType = function(val) {
	if (!val) return null
	if (val.numberValue !== undefined && val.numberValue !== null)
		return "numberValue"
	if (val.stringValue !== undefined && val.stringValue !== null)
		return "stringValue"
	if (val.dateValue !== undefined && val.dateValue !== null) return "dateValue"
	if (val.booleanValue !== undefined && val.booleanValue !== null)
		return "booleanValue"
	if (val.arrayValue !== undefined && val.arrayValue !== null)
		return "arrayValue"
	if (val.objectValue !== undefined && val.objectValue !== null)
		return "objectValue"
	return null
}

export default {
	name: "EndorsementHandler",
	render: function() {
		return this.$scopedSlots.default({
			...this.$data.endorsements
		})
	},
	props: {
		isEditable: Boolean,
		value: {
			type: Object,
			default: () => ({
				activeEndorsement: {},
				addedEndorsements: []
			})
		},
		policyId: {
			type: String
		},
		endorsementId: {
			type: String
		},
		policy: {
			type: Object,
			required: true
		},
		unsavedEndorsements: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			endorsements: {
				policySection: {
					componentProps: {
						root: {
							list: [
								{
									label: this.$t("policy_number"),
									value: this.policy.issuerNumber,
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseInputText",
									update: input => {
										if (input === this.policy.issuerNumber)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { issuerNumber: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("start_date"),
									value:
										this.policy.startDate &&
										dayjs(this.policy.startDate).format(
											this.$store.state.settings.dateFormat
										),
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseDatePickerSimple",
									update: input => {
										if (input === this.policy.startDate)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { startDate: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("end_date"),
									value:
										this.policy.endDate &&
										dayjs(this.policy.endDate).format(
											this.$store.state.settings.dateFormat
										),
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseDatePickerSimple",
									update: input => {
										if (input === this.policy.endDate)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { endDate: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("issue_date"),
									value:
										this.policy.issueDate &&
										dayjs(this.policy.issueDate).format(
											this.$store.state.settings.dateFormat
										),
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseDatePickerSimple",
									update: input => {
										if (input === this.policy.issueDate)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { issueDate: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("description"),
									value: this.policy.description,
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseInputText",
									update: input => {
										if (input === this.policy.description)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { description: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("source"),
									value: this.policy.source,
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseInputText",
									update: input => {
										if (input === this.policy.source)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { source: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("policy_status"),
									value: this.policy.status,
									actions: [],
									component: "JBaseInputText",
									update: input => {
										if (input === this.policy.status)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { status: input },
												store: this.$store
											})
									}
								},
								{
									label: this.$t("referral_code"),
									value: this.policy.referralCode,
									actions: this.isEditable ? ["update"] : [],
									component: "JBaseInputText",
									update: input => {
										if (input === this.policy.referralCode)
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										else
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { referralCode: input },
												store: this.$store
											})
									}
								}
							]
						},
						facts: {
							list: this.policy.facts
								? this.getFactsList(
										this.policy.facts,
										this.$t("policy"),
										updatePolicyFact,
										removePolicyFact
								  )
								: []
						}
					},
					componentHandlers: {
						"item:update": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"item:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$emit("endorse:remove")
						}
					},
					sectionHandlers: {
						"fact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_fact"),
									component: "InputNewFact",
									add: input => {
										return addPolicyFact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
					}
				},
				productSection: {
					componentProps: {
						root: {
							list: [
								{
									label: this.$t("plan"),
									value: this.policy?.product?.productId?.plan,
									actions: []
								},
								{
									label: this.$t("version"),
									value: this.policy?.product?.productId?.version,
									actions: []
								},
								{
									label: this.$t("type"),
									value: this.policy?.product?.productId?.type,
									actions: []
								}
							]
						}
					},
					sectionHandlers: {
						"product:update": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									label: this.$t("select_product"),
									component: "CoreSelectProduct",
									whiteSpaceUnder: true,
									value: [this.policy?.product],
									update: input => {
										if (input === this.policy?.product?.productId?.plan) {
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
											return
										}
										return updatePolicy({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input: { productId: input[0]?.productId },
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
					}
				},
				premiumSection: {
					componentProps: {
						pricing: this.policy.premium,
						productId: this?.product?.productId
					},
					componentHandlers: {
						"gross_premium:open_modal": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...deepClone(e),
									update: (
										premiumInput // handles update event from modal with arguments from gql endpoint
									) => {
										if (
											premiumInput.grossAmount ===
											this.policy?.premium?.originalPrice
										) {
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										} else {
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: { premium: premiumInput },
												store: this.$store
											})
										}
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"discount:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...deepClone({
										...e,
										label: this.$t("discount")
									}),
									remove: () => {
										return removeDiscount({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											discountId: e.id,
											store: this.$store
										})
									}
								}
							})
							this.$emit("endorse:remove")
						},
						"discount:open_modal": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...deepClone(e),
									add: addDiscountInput => {
										// Handle discount with code
										if (addDiscountInput.withCode) {
											if (
												this.policy?.premium?.discountCodes?.find(
													discount => discount === addDiscountInput?.code
												)
											) {
												eHandler(
													"This code has already been applied",
													{ status: "error" },
													this.$store
												)
											}
											const discountCodes = this.policy?.premium?.discountCodes
												? this.policy.discountCodes.concat(
														addDiscountInput.code
												  )
												: [addDiscountInput.code]
											return updatePolicy({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: {
													premium: {
														discountCodes
													}
												},
												store: this.$store
											})
										} else {
											// Handle ad hoc discount
											return addDiscount({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												input: {
													calculationJsonLogic:
														addDiscountInput?.calculationJsonLogic,
													order: addDiscountInput?.order,
													name: addDiscountInput?.name
												},
												store: this.$store
											})
										}
									},
									update: (
										updateDiscountOfOfferInput // handles update event from modal with arguments from gql endpoint
									) => {
										if (
											updateDiscountOfOfferInput.calculationJsonLogic ===
											this.policy.premium.appliedDiscounts?.calculationJsonLogic
										) {
											eHandler(
												this.$t("errors.cannot_update_without_changing_value"),
												{ status: "unchanged" },
												this.$store
											)
										} else {
											return updateDiscount({
												policyId: this.policyId,
												endorsementId: this.endorsementId,
												discountId: updateDiscountOfOfferInput.discountId
											})
										}
									}
								}
							})

							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"loadings:open_modal": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...e,
									hideLabel: true,
									add: addLoadingInput => {
										if (!addLoadingInput.code) {
											this.$store.dispatch("addMessage", {
												message: {
													type: "error",
													text: this.$t("errors.loading_code_required")
												}
											})
											return
										}
										return addLoading({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input: {
												code: addLoadingInput?.code,
												[addLoadingInput.type]:
													addLoadingInput.type === "ratio"
														? addLoadingInput?.amount / 100
														: addLoadingInput?.amount,
												order: addLoadingInput?.order || 0
											},
											store: this.$store
										})
									}
								}
							})

							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"loading:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...deepClone({
										...e,
										label: this.$t("loadings")
									}),
									remove: () => {
										console.log("removing loading", e)
										return removeLoading({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											loadingId: e.id,
											store: this.$store
										})
									}
								}
							})
							this.$emit("endorse:remove")
						}
					}
				},
				clausesSection: {
					componentProps: {
						clauses: this.policy.clauses
					},
					componentHandlers: {
						clauses_add: e => {
							/**
							 * Saves clause add to endorsement
							 *
							 * @param {Object} input - gql addClauseInput Type
							 * @param {int} input.order
							 * @param {string} input.templateId
							 * @param {Object} input.renderParameters - templateRenderParametersInput
							 * @param {string} input.renderParameters.name
							 * @param {string} input.renderParameters.contentJsonString
							 * @param {string} input.renderParameters.variablesJsonString
							 *
							 */
							const add = input => {
								return addAddClauseToEndorsement({
									policyId: this.policyId,
									endorsementId: this.endorsementId,
									input,
									store: this.$store
								})
							}
							const newClausesLength = this.unsavedEndorsements.filter(
								({ label }) => label === "addClauseCommands"
							).length

							let modifiedEvent = deepClone(e)
							modifiedEvent.value.order = newClausesLength || 0

							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...modifiedEvent,
									type: "add",
									newClausesLength,
									label: this.$t("clause"),
									component: "ClausesAdd",
									componentProps: { tag: "endorsement" },
									add
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
						/*
						clause_remove: e => {
							console.log({ e })
							removeClause(this.policyId, this.endorsementId, e.clauseId)
						}
						*/
					}
				},
				pricingSection: {
					sectionHandlers: {
						click: e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									label: this.$t("pricing"),
									component: "AegPricing",
									hideButtons: true,
									componentProps: {
										isEditable: true,
										isPremiumOverriden: this.policy.isPremiumOverriden,
										endorsementId: this.endorsementId,
										rawValues: deepClone(this.policy.values),
										policyId: this.policy.id,
										clauses: this.policy.clauses,
										productId: this.policy.product.productId,
										contractInsured: this.policy.contractInsured
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
					}
				},
				holderSection: this.policy.contractHolder && {
					component: "DataList",
					componentProps: {
						root: {
							list:
								this.policy.contractHolder.__typename == "company"
									? this.getCompanyRootList(
											this.$t("holder"),
											this.policy.contractHolder,
											updatePolicy,
											null
									  )
									: this.getIndividualRootList(
											this.$t("holder"),
											this.policy.contractHolder,
											updatePolicy,
											null
									  )
						},
						identities: {
							list: this.policy.contractHolder.identities
								? this.getBasicList(
										"identity",
										this.policy.contractHolder.identities,
										this.$t("holder"),
										updateContractHolderIdentity,
										removeContractHolderIdentity,
										null
								  )
								: []
						},
						addresses: {
							list: this.policy.contractHolder.addresses
								? this.getBasicList(
										"address",
										this.policy.contractHolder.addresses,
										this.$t("holder"),
										updateContractHolderAddress,
										removeContractHolderAddress,
										null
								  )
								: []
						},
						contacts: {
							list: this.policy.contractHolder.contacts
								? this.getBasicList(
										"contact",
										this.policy.contractHolder.contacts,
										this.$t("holder"),
										updateContractHolderContact,
										removeContractHolderContact,
										null
								  )
								: []
						},
						facts: {
							list: this.policy.contractHolder.facts
								? this.getFactsList(
										this.policy.contractHolder.facts,
										this.$t("holder"),
										updateContractHolderFact,
										removeContractHolderFact,
										null
								  )
								: []
						}
					},
					componentHandlers: {
						"item:update": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"item:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$emit("endorse:remove")
						}
					},
					sectionHandlers: {
						"contact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_contact"),
									component: "InputNewContact",
									add: input => {
										return addContractHolderContact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"address:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_address"),
									component: "InputNewAddress",
									add: input => {
										return addContractHolderAddress({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"identity:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_identity"),
									component: "InputNewIdentity",
									add: input => {
										return addContractHolderIdentity({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"fact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_fact"),
									component: "InputNewFact",
									add: input => {
										return addContractHolderFact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
					}
				},
				otherHoldersSection: this.getOtherHoldersList(
					this.policy.otherContractHolders
				),
				insuredListSection: this.getInsuredList(this.policy.contractInsured),
				bindersSection: {
					componentProps: {
						list: this.policy?.associatedContracts
					},
					sectionHandlers: {
						"binders:open_modal": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									label: this.$t("associated_contracts"),
									component: "CoreSelectBinders",
									whiteSpaceUnder: true,
									value: [],
									type: "add",
									add: list => {
										return addAssociatedContractToPolicy({
											policyId: this.policyId,
											associatedContractId: list[0].id,
											endorsementId: this.endorsementId,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"binders:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									...deepClone({
										value: e,
										label: this.$t("associated_contracts")
									}),
									remove: binderId => {
										return removeAssociatedContractFromPolicy({
											policyId: this.policyId,
											associatedContractId: binderId,
											endorsementId: this.endorsementId,
											store: this.$store
										})
									}
								}
							}),
								this.$emit("endorse:remove")
						}
					}
				},
				benefitOptionsSection: {
					componentProps: {
						list: this.getBenefitOptionsList(this?.policy.benefitOptions || [])
					},
					sectionHandlers: {
						"benefit_option:open_modal": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									label: "Add Benefit Option",
									hideLabel: true,
									modalWidth: 1200,
									hideButtons: true,
									type: "add",
									value: this?.policy?.product?.benefitGraph || [],
									component: "CoreSelectBenefitOption",
									add: ({ value, optionKey, typeId }) => {
										return upsertBenefitOptionOfPolicy({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input: { value, key: optionKey, typeId },
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"option:remove": option => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: { ...option }
							})
							this.$emit("endorse:remove")
						},
						"option:update": item => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									label: "Update Benefit Option",
									hideLabel: true,
									hideButtons: true,
									type: "update",
									value: this?.policy?.product?.benefitGraph || [],
									component: "CoreSelectBenefitOption",
									componentProps: {
										initialBenefitTypeId: item?.typeId,
										initialInputValue: item?.value,
										initialInputDataType: item?.dataType
									},
									update: ({ value, optionKey, typeId }) => {
										return upsertBenefitOptionOfPolicy({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											input: { value, key: optionKey, typeId },
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						}
					}
				}
			}
		}
	},

	methods: {
		// Returns the schema for benefit options display
		getBenefitOptionsList(list) {
			return list.map(option => {
				return {
					label: option?.name,
					value:
						option?.formattedValue !== null
							? option?.formattedValue
							: parseScalarValue(option?.value),
					dataType: getDataType(option?.value),
					actions: ["update", "remove"],
					typeId: option?.benefitTypeId,
					optionKey: option?.key,
					remove: () => {
						return removeBenefitOptionFromPolicy({
							policyId: this.policyId,
							endorsementId: this.endorsementId,
							typeId: option?.benefitTypeId,
							store: this.$store
						})
					}
				}
			})
		},

		// Returns the list of objects representing other holder people. Each element is a whole other holder section
		// Handles if an holder is an individual, a company or an object
		getOtherHoldersList(list) {
			return list.map((otherHolder, i) => {
				return {
					component: "DataList",
					componentProps: {
						root: {
							list:
								otherHolder.__typename == "company"
									? this.getCompanyRootList(
											this.$t("other_holder") + " " + parseInt(i + 1),
											otherHolder,
											updateOtherContractHolderCompany,
											otherHolder.id
									  )
									: this.getIndividualRootList(
											this.$t("other_holder") + " " + parseInt(i + 1),
											otherHolder,
											updateOtherContractHolderIndividual,
											otherHolder.id
									  )
						},
						identities: {
							list: otherHolder.identities
								? this.getBasicList(
										"identity",
										otherHolder.identities,
										this.$t("other_holder") + " " + parseInt(i + 1),
										updateOtherContractHolderIdentity,
										removeOtherContractHolderIdentity,
										otherHolder.id
								  )
								: []
						},
						addresses: {
							list: otherHolder.addresses
								? this.getBasicList(
										"address",
										otherHolder.addresses,
										this.$t("other_holder") + " " + parseInt(i + 1),
										updateOtherContractHolderAddress,
										removeOtherContractHolderAddress,
										otherHolder.id
								  )
								: []
						},
						contacts: {
							list: otherHolder.contacts
								? this.getBasicList(
										"contact",
										otherHolder.contacts,
										this.$t("other_holder") + " " + parseInt(i + 1),
										updateOtherContractHolderContact,
										removeOtherContractHolderContact,
										otherHolder.id
								  )
								: []
						},
						facts: {
							list: otherHolder.facts
								? this.getFactsList(
										otherHolder.facts,
										this.$t("other_holder") + " " + parseInt(i + 1),
										updateOtherContractHolderFact,
										removeOtherContractHolderFact,
										otherHolder.id
								  )
								: []
						}
					},
					componentHandlers: {
						"item:update": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"item:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$emit("endorse:remove")
						}
					},
					sectionHandlers: {
						"contact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_contact"),
									component: "InputNewContact",
									add: input => {
										return addOtherContractHolderContact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: otherHolder.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"address:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_address"),
									component: "InputNewAddress",
									add: input => {
										return addOtherContractHolderAddress({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: otherHolder.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"identity:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_identity"),
									component: "InputNewIdentity",
									add: input => {
										return addOtherContractHolderIdentity({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: otherHolder.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"fact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_fact"),
									component: "InputNewFact",
									add: input => {
										return addOtherContractHolderFact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: otherHolder.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"remove:section": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "remove",
									value: {},
									label: this.$t("remove_other_holder"),
									remove: () => {
										return removeOtherContractHolder({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: otherHolder.id,
											store: this.$store
										})
									}
								}
							})
							this.$emit("endorse:remove")
						}
					}
				}
			})
		},

		// Returns the list of objects representing insured people. Each element is a whole insured section
		// Handles if an insured is an individual, a company or an object
		getInsuredList(list) {
			return list.map((insured, i) => {
				return {
					component: "DataList",
					componentProps: {
						root: {
							list:
								insured.__typename == "company"
									? this.getCompanyRootList(
											this.$t("insured") + " " + parseInt(i + 1),
											insured,
											updateContractInsuredCompany,
											insured.id
									  )
									: insured.__typename == "individual"
									? this.getIndividualRootList(
											this.$t("insured") + " " + parseInt(i + 1),
											insured,
											updateContractInsuredIndividual,
											insured.id
									  )
									: this.getObjectRootList(
											this.$t("insured") + " " + parseInt(i + 1),
											insured,
											updateContractInsuredObject,
											insured.id
									  )
						},
						identities: {
							list: insured.identities
								? this.getBasicList(
										"identity",
										insured.identities,
										this.$t("insured") + " " + parseInt(i + 1),
										updateContractInsuredIdentity,
										removeContractInsuredIdentity,
										insured.id
								  )
								: []
						},
						addresses: {
							list: insured.addresses
								? this.getBasicList(
										"address",
										insured.addresses,
										this.$t("insured") + " " + parseInt(i + 1),
										updateContractInsuredAddress,
										removeContractInsuredAddress,
										insured.id
								  )
								: []
						},
						contacts: {
							list: insured.contacts
								? this.getBasicList(
										"contact",
										insured.contacts,
										this.$t("insured") + " " + parseInt(i + 1),
										updateContractInsuredContact,
										removeContractInsuredContact,
										insured.id
								  )
								: []
						},
						facts: {
							list: insured.facts
								? this.getFactsList(
										insured.facts,
										this.$t("insured") + " " + parseInt(i + 1),
										updateContractInsuredFact,
										removeContractInsuredFact,
										insured.id
								  )
								: []
						}
					},
					componentHandlers: {
						"item:update": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"item:remove": e => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: deepClone(e)
							})
							this.$emit("endorse:remove")
						}
					},
					sectionHandlers: {
						"contact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_contact"),
									component: "InputNewContact",
									add: input => {
										return addContractInsuredContact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: insured.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"address:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_address"),
									component: "InputNewAddress",
									add: input => {
										return addContractInsuredAddress({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: insured.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"identity:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_identity"),
									component: "InputNewIdentity",
									add: input => {
										return addContractInsuredIdentity({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: insured.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"fact:add": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "add",
									value: {},
									label: this.$t("new_fact"),
									component: "InputNewFact",
									add: input => {
										return addContractInsuredFact({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: insured.id,
											input,
											store: this.$store
										})
									}
								}
							})
							this.$nextTick().then(() => {
								this.$modal.show("modalEditor")
							})
						},
						"remove:section": () => {
							this.$emit("input", {
								...this.value,
								activeEndorsement: {
									type: "remove",
									value: {},
									label: this.$t("remove_insured"),
									component: "InputNewFact",
									remove: () => {
										return removeContractInsured({
											policyId: this.policyId,
											endorsementId: this.endorsementId,
											entityId: insured.id,
											store: this.$store
										})
									}
								}
							})
							this.$emit("endorse:remove")
						}
					}
				}
			})
		},

		// Returns array containing objects for every fields of the list param (Contacts, Addresses, Identities..)
		// Prefix is just for the label, to differentiate holders and insured
		getBasicList(category, list, prefix, updateCall, removeCall, entityId) {
			return list.map(item => {
				const itemValue = category == "address" ? item.fields2 : item.value
				return {
					label: " " + item.type,
					value: itemValue,
					actions: this.isEditable ? ["update", "remove"] : [],
					component:
						category == "address" ? "UpdateAddressInput" : "JBaseInputText",
					update: input => {
						if (input === itemValue) {
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
							return
						}
						const updateItemInput = {
							id: item.id,
							type: item.type,
							...(category === "address" && { fields: input }),
							...(category !== "address" && { value: input })
						}
						return updateCall({
							policyId: this.policyId,
							endorsementId: this.endorsementId,
							contactId: item.id,
							addressId: item.id,
							identityId: item.id,
							...(entityId && { entityId }),
							input: updateItemInput,
							store: this.$store
						})
					},
					remove: () => {
						return removeCall({
							policyId: this.policyId,
							endorsementId: this.endorsementId,
							contactId: item.id,
							addressId: item.id,
							identityId: item.id,
							...(entityId && { entityId }),
							store: this.$store
						})
					}
				}
			})
		},

		// Returns the list of fields for each fact
		// Prefix is just for the label, to differentiate holders and insured
		getFactsList(facts, prefix, updateCall, removeCall, entityId) {
			// Function that take a scalarValueInput and return the type which has a non-null value
			const getValueType = value =>
				value
					? Object.keys(value).find(key => value[key] !== null)
					: "stringValue"
			return facts
				.filter(fact =>
					filterGuidAndObjectId(
						fact?.value?.arrayValue
							? fact.value.arrayValue[0]?.stringValue
							: fact?.value?.stringValue
					)
				)
				.map(fact => {
					// Build an object for each fact
					fact.value = fact.value || { stringValue: "" }
					const valueType = getValueType(fact.value)
					// Function to remove useless objects in array and stringify it
					const parseFactArray = function(array) {
						const filteredArray = array.map(item => {
							return { [getValueType(item)]: item[getValueType(item)] }
						})
						return JSON.stringify(filteredArray)
							.replace(/\[/g, "[\n    ")
							.replace(/{/g, "{\n        ")
							.replace(/},/g, "\n    },\n    ")
							.replace(/}\]/g, "\n    }\n]")
							.replace(/:/g, " : ")
					}
					const value =
						valueType == "arrayValue"
							? parseFactArray(fact.value[valueType])
							: valueType == "objectValue"
							? JSON.stringify(fact.value[valueType])
							: valueType === "dateValue"
							? dayjs(fact.value[valueType]).format(
									this.$store.state.settings.dateFormat
							  )
							: fact.value[valueType]
					return {
						label: " " + fact.type,
						value: value,
						valueType: valueType,
						actions: this.isEditable ? ["update", "remove"] : [],
						component:
							valueType == "dateValue"
								? "JBaseDatePickerSimple"
								: valueType == "numberValue"
								? "JBaseInputNumber"
								: valueType == "booleanValue"
								? "JBaseToggle"
								: valueType == "arrayValue" || valueType == "objectValue"
								? "JBaseInputLongText"
								: "JBaseInputText",
						update: input => {
							if (input === value) {
								eHandler(
									this.$t("errors.cannot_update_without_changing_value"),
									{ status: "unchanged" },
									this.$store
								)
								return
							}
							// Need to format the input to the updateFactInput!
							if (valueType == "arrayValue" || valueType == "objectValue")
								input = JSON.parse(input)
							const updateFactInput = {
								id: fact.id,
								type: fact.type,
								value: { [valueType]: input },
								values: null
							}
							return updateCall({
								policyId: this.policyId,
								endorsementId: this.endorsementId,
								factId: fact.id,
								...(entityId && { entityId }),
								input: updateFactInput,
								store: this.$store
							})
						},
						remove: () => {
							return removeCall({
								policyId: this.policyId,
								endorsementId: this.endorsementId,
								factId: fact.id,
								...(entityId && { entityId }),
								store: this.$store
							})
						}
					}
				})
		},

		// Build the list of root fields if the entity is an object
		getObjectRootList(prefix, dataFromPolicy, updateCall, entityId) {
			return [
				{
					label: this.$t("name"),
					value: dataFromPolicy.name,
					linkTo: `/${this.$store.state.tenantId}/clients/detail/${
						dataFromPolicy.id
					}/overview/object`,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						if (input === dataFromPolicy.name)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return entityId
								? updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										entityId,
										input: {
											nameFormat: input
										},
										store: this.$store
								  })
								: updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										input: {
											nameFormat: input
										},
										store: this.$store
								  })
					}
				},
				{
					label: this.$t("photo_path"),
					value: dataFromPolicy.photoPath,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						if (input === dataFromPolicy.photoPath)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return entityId
								? updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										entityId,
										input: {
											photoPath: input
										},
										store: this.$store
								  })
								: updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										input: {
											photoPath: input
										},
										store: this.$store
								  })
					}
				},
				{
					label: this.$t("source"),
					value: dataFromPolicy.source,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						if (input === dataFromPolicy.source)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return entityId
								? updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										entityId,
										input: {
											source: input
										},
										store: this.$store
								  })
								: updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										input: {
											source: input
										},
										store: this.$store
								  })
					}
				},
				{
					label: this.$t("type_id"),
					value: dataFromPolicy.typeId,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						if (input === dataFromPolicy.typeId)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return entityId
								? updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										entityId,
										input: {
											typeId: input
										},
										store: this.$store
								  })
								: updateCall({
										policyId: this.policyId,
										endorsementId: this.endorsementId,
										input: {
											typeId: input
										},
										store: this.$store
								  })
					}
				}
			]
		},

		// Build the list of root fields if the entity (both holder or insured) is an individual
		getIndividualRootList(prefix, dataFromPolicy, updateCall, entityId) {
			return [
				{
					label: this.$t("name"),
					value: dataFromPolicy.name,
					linkTo: `/${this.$store.state.tenantId}/clients/detail/${
						dataFromPolicy.id
					}/overview/individual`,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { nameFormat: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.name)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("english_first_name"),
					value: dataFromPolicy.englishFirstName,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { englishFirstName: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.englishFirstName)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("english_last_name"),
					value: dataFromPolicy.englishLastName,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { englishLastName: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.englishLastName)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("chinese_first_name"),
					value: dataFromPolicy.chineseFirstName,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { chineseFirstName: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.chineseFirstName)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("english_last_name"),
					value: dataFromPolicy.chineseLastName,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { chineseLastName: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.chineseLastName)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("date_of_birth"),
					value: dataFromPolicy.dateOfBirth,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseDatePickerSimple",
					update: input => {
						const rootInput = { dateOfBirth: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.dateOfBirth)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("gender"),
					value: dataFromPolicy.gender,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { gender: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.gender)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("occupation"),
					value: dataFromPolicy.occupation,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { occupation: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.occupation)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("marital_status"),
					value: dataFromPolicy.maritalStatus,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { maritalStatus: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.maritalStatus)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("employment_status"),
					value: dataFromPolicy.employmentStatus,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { employmentStatus: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.employmentStatus)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("salutation"),
					value: dataFromPolicy.salutation,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { salutation: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.salutation)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("preferred_communication"),
					value: dataFromPolicy.preferredCommunicationChannel,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { preferredCommunicationChannel: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.preferredCommunicationChannel)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("preferred_language"),
					value: dataFromPolicy.preferredLanguage,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { preferredLanguage: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.preferredLanguage)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("country"),
					value: dataFromPolicy.countryOfResidency,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { countryOfResidency: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.countryOfResidency)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("internal_code"),
					value: dataFromPolicy.internalCode,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { internalCode: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.internalCode)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("accepts_marketing"),
					value: dataFromPolicy.acceptsMarketing,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseToggle",
					update: input => {
						const rootInput = { acceptsMarketing: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.acceptsMarketing)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("photo_path"),
					value: dataFromPolicy.photoPath,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { photoPath: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.photoPath)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("source"),
					value: dataFromPolicy.source,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { source: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderIndividual: rootInput
							})
						}
						if (input === dataFromPolicy.source)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				}
			]
		},
		// Build the list of fields if the entity (both holder or insured) is a company
		getCompanyRootList(prefix, dataFromPolicy, updateCall, entityId) {
			return [
				{
					label: this.$t("name"),
					value: dataFromPolicy.name,
					linkTo: `/${this.$store.state.tenantId}/clients/detail/${
						dataFromPolicy.id
					}/overview/company`,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { nameFormat: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.name)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								endorsementId: this.endorsementId,
								...(entityId && { entityId }),
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("registration_number"),
					value: dataFromPolicy.registrationNumber,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { registrationNumber: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.registrationNumber)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("nature_of_business"),
					value: dataFromPolicy.natureOfBusiness,
					actions: this.isEditable ? ["update"] : [],
					component: "InputNatureOfBusiness",
					update: input => {
						const rootInput = { natureOfBusiness: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.natureOfBusiness)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("photo_path"),
					value: dataFromPolicy.photoPath,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { photoPath: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.photoPath)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("accepts_marketing"),
					value: dataFromPolicy.acceptsMarketing,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseToggle",
					update: input => {
						const rootInput = { acceptsMarketing: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.acceptsMarketing)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				},
				{
					label: this.$t("source"),
					value: dataFromPolicy.source,
					actions: this.isEditable ? ["update"] : [],
					component: "JBaseInputText",
					update: input => {
						const rootInput = { source: input }
						const updateInput = {
							...(entityId && rootInput),
							...(!entityId && {
								contractHolderCompany: rootInput
							})
						}
						if (input === dataFromPolicy.source)
							eHandler(
								this.$t("errors.cannot_update_without_changing_value"),
								{ status: "unchanged" },
								this.$store
							)
						else
							return updateCall({
								policyId: this.policyId,
								...(entityId && { entityId }),
								endorsementId: this.endorsementId,
								input: updateInput,
								store: this.$store
							})
					}
				}
			]
		}
	}
}
</script>

<style></style>
